module.exports = __webpack_public_path__ + "static/img/QLD-6.45ec1ae.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/QLD-6.jpg
// module id = Cx74
// module chunks = 0